module.exports = __webpack_public_path__ + "static/media/zameen-quadrangle-penthouse.1f65824a.jpg";